import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';

import { HChartstockComponent } from './hchartstock.component';
import { HChartstockRestComponent } from './hchartstock-rest.component';

declare var require: any;
export function highchartsFactory() {
    const hc = require('highcharts/highstock');
    var exp = require('highcharts/modules/exporting');
    exp(hc);
    return hc;
}

@NgModule({
    imports: [
        CommonModule,
        ChartModule
    ],
    exports: [
        HChartstockComponent,
        HChartstockRestComponent
    ],
    declarations: [
        HChartstockComponent,
        HChartstockRestComponent
    ],
    providers: [
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory
        }
    ]
})

export class HChartstockModule { }